import { render, staticRenderFns } from "./wpgextendedReports.vue?vue&type=template&id=57fa6014&scoped=true"
import script from "./wpgextendedReports.vue?vue&type=script&lang=js"
export * from "./wpgextendedReports.vue?vue&type=script&lang=js"
import style0 from "./wpgextendedReports.vue?vue&type=style&index=0&id=57fa6014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa6014",
  null
  
)

export default component.exports